import Footer from "../../components/Footer";
import LanImg_2 from "../../assets/img/ourStory.png";
import LanIcon_3 from "../../assets/img/Black.png";
import IELTS_IMG_1 from "../../assets/img/ielts_section.png";
import "../style.css";
import { useParams } from "react-router-dom";
import LanImg_1 from "../../assets/img/ieltts.png";
import LanguageLearnMore from "./LanguageLearnMore";
export default function IELTS() {
  const { id } = useParams();
  const learnMoreData = {
    pageName: "IELTS",
    heroSection: {
      header1: "IELTS for",
      header2: "university entry",
      desc: "Access study materials, practice tests, and one-on-one tutoring with Global StudyIn, giving yourself the best chance of hitting the score you need.",
      rightImg: LanImg_1,
    },
    aboutTestSection: {
      img: LanImg_2,
      header: "What is IELTS?",
      descImg: IELTS_IMG_1,
      desc1:
        "IELTS, the International English Language Testing System, is a test of English language proficiency and one of the world’s most popular and respected forms of English in education and migration. Intended for non-native speakers who are looking to study or work in an English-speaking environment, IELTS training is an internationally recognised system for testing English language ability in four categories:",
      desc2:
        "Since its introduction in 1989, IELTS preparation has become one of the most trusted forms of English-language assessment and is accepted by over 8,000 universities, employers, and At Global StudyIn, you have access to a range of free and paid resources and IELTS coaching, giving you a better chance of meeting the entry requirements of your preferred university.",
    },

    scoreSection: {
      header: "IELTS course types",
      desc: "There are two different types of IELTS tests, and once graded, your IELTS score is valid for two years.",
      cards: [
        {
          img: LanIcon_3,
          header: "Academic IELTS",
          desc: "Academic IELTS is for international students who wish to study at a university or join an institute of higher education.",
        },
        {
          img: LanIcon_3,
          header: "General IELTS",
          desc: "Classes focus on English survival skills and social and workplace language, ideal for those planning to migrate to English-speaking countries such as Australia, Canada, or New Zealand.",
        },
      ],
    },
    testFormatSection: {
      header: "IELTS 9-Band Scale",
      desc: "",
      tableData: {
        rowHeader: ["Score", "Skill", "Skill overview"],
        rowData: [
          {
            column1: "Band 9",
            column2: "Expert",
            column3:
              "Fully operational command of the language. Accurate and fluent with complete understanding",
          },
          {
            column1: "Band 8",
            column2: "Very good",
            column3:
              "Fully operational command with occasional minor errors. Handles complex language well",
          },

          {
            column1: "Band 7",
            column2: "Good",
            column3:
              "Strong command with occasional inaccuracies and misunderstandings in unfamiliar situations",
          },
          {
            column1: "Band 6",
            column2: "Competent",
            column3:
              "Generally effective command, though with some errors and misunderstandings",
          },
          {
            column1: "Band 5",
            column2: "Modest",
            column3:
              "Partial command, coping with overall meaning but frequent errors",
          },
          {
            column1: "Band 4",
            column2: "Limited",
            column3:
              "Basic competence in familiar situations, but difficulties in understanding and expressing complex ideas",
          },
          {
            column1: "Band 3",
            column2: "Extremely limited",
            column3:
              "Conveys and understands only the general meaning in very familiar situations and experiences frequent breakdowns in communication",
          },
          {
            column1: "Band 2",
            column2: "Intermittent",
            column3:
              "Great difficulty understanding spoken and written English and struggles to communicate basic ideas",
          },
          {
            column1: "Band 1",
            column2: "Non-user",
            column3:
              "No ability to use the language except for a few isolated words",
          },
          {
            column1: "Band 0",
            column2: "Did not attempt the test",
            column3:
              "The test was not taken, or there is no assessable English proficiency",
          },
        ],
      },
    },
  };

  return (
    <div className="ielts">
      <LanguageLearnMore learnMoreData={learnMoreData} />

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
